export type AssetId =
  | 'player-droplet'
  | 'platform-wet-tile'
  | 'splash-burst'
  | 'restart-button'
  | 'hazard-thorn-puddle'
  | 'logo-the-drip'
  | 'background-rainy'
  | 'power-heal'
  | 'power-sticky'
  | 'power-slippery'
  | 'power-direction-swap'
  | 'power-speed'
  | 'power-jump'
  | 'power-multiball';

const assetPaths: Record<AssetId, string> = {
  'player-droplet': '/assets/generated/player-droplet.png',
  'platform-wet-tile': '/assets/generated/platform-wet-tile.png',
  'splash-burst': '/assets/generated/splash-burst.png',
  'restart-button': '/assets/generated/restart-button.png',
  'hazard-thorn-puddle': '/assets/generated/hazard-thorn-puddle.png',
  'logo-the-drip': '/assets/generated/logo-the-drip.png',
  'background-rainy': '/assets/generated/background-rainy.jpg',
  'power-heal': '/assets/generated/power-heal.png',
  'power-sticky': '/assets/generated/power-sticky.png',
  'power-slippery': '/assets/generated/power-slippery.png',
  'power-direction-swap': '/assets/generated/power-direction-swap.png',
  'power-speed': '/assets/generated/power-speed.png',
  'power-jump': '/assets/generated/power-jump.png',
  'power-multiball': '/assets/generated/power-multiball.png'
};

export type GameAssets = Record<AssetId, HTMLImageElement>;

export async function loadGameAssets(): Promise<GameAssets> {
  const entries = await Promise.all(
    Object.entries(assetPaths).map(async ([id, src]) => [id, await loadImage(src)] as const)
  );

  return Object.fromEntries(entries) as GameAssets;
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.decoding = 'async';
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error(`Failed to load ${src}`));
    image.src = src;
  });
}
